function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("path", {
  d: "M17.5,35 C27.1649831,35 35,27.1649831 35,17.5 C35,7.83501688 27.1649831,0 17.5,0 C7.83501688,0 0,7.83501688 0,17.5 C0,27.1649831 7.83501688,35 17.5,35 Z M17.5,33 C8.93958638,33 2,26.0604136 2,17.5 C2,8.93958638 8.93958638,2 17.5,2 C26.0604136,2 33,8.93958638 33,17.5 C33,26.0604136 26.0604136,33 17.5,33 Z"
}), React.createElement("path", {
  d: "M10.623627,12.0449441 L21.7208464,10.9561689 C22.270492,10.9022418 22.7597844,11.3041011 22.8137115,11.8537467 C22.8200829,11.9186865 22.8200829,11.9840941 22.8137115,12.0490339 L21.7249363,23.1462533 C21.6710092,23.6958989 21.1817169,24.0977582 20.6320712,24.0438311 C20.4016932,24.0212282 20.1862921,23.9194005 20.022608,23.7557165 L10.0141638,13.7472723 C9.62363956,13.356748 9.62363956,12.723583 10.0141638,12.3330587 C10.1778479,12.1693747 10.393249,12.067547 10.623627,12.0449441 Z",
  transform: "translate(16.269880, 17.500000) rotate(45.000000) translate(-16.269880, -17.500000) "
}))));

const SvgStartSessionIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgStartSessionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/start-session-icon.4e5bc88b.svg";
export { ForwardRef as ReactComponent };